import { useEffect, useState } from "react";
import type {
  FC,
  ChangeEventHandler,
  FormEventHandler,
  MouseEventHandler,
  SyntheticEvent,
} from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  InputLabel,
  OutlinedInput,
  Stack,
} from "@mui/material";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { useEditPlaylistMutation } from "store/current-user/current-user.api";

export const EditPlaylistMenu: FC = () => {
  const [name, setName] = useState<string>("");
  const [isPublic, setIsPublic] = useState<boolean>(false);

  const { editPlaylistMenu } = useShallowPickSelector("app", [
    "editPlaylistMenu",
  ]);
  const { user } = useShallowPickSelector("currentUser", ["user"]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const [editPlaylist, { isLoading, isSuccess }] = useEditPlaylistMutation();

  useEffect(() => {
    if (editPlaylistMenu.playlist) {
      setName(editPlaylistMenu.playlist.name);
      setIsPublic(editPlaylistMenu.playlist.public!);
      console.log(editPlaylistMenu.playlist);
    }
  }, [editPlaylistMenu]);

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess]);

  const onClose = () => {
    dispatch(
      appActions.setEditPlaylistMenu({
        isOpen: false,
        playlist: null,
      })
    );
  };

  const onChangeName: ChangeEventHandler<HTMLInputElement> = (event) => {
    let value = event.target.value;
    setName(value);
  };

  const onChangeIsPublic = (event: SyntheticEvent, checked: boolean) => {
    setIsPublic(checked);
  };

  const onSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    if (!user || !editPlaylistMenu.playlist || name.length === 0) return;
    editPlaylist({
      playlistId: editPlaylistMenu.playlist.id,
      body: { name, public: isPublic },
    });
  };

  return (
    <BottomSheet
      title={"ویرایش پلی‌لیست"}
      isOpen={editPlaylistMenu.isOpen}
      onClose={onClose}
    >
      <Stack component={"form"} onSubmit={onSubmit}>
        <Stack mx={3} mt={1} mb={6}>
          <InputLabel htmlFor={"playlist-name"}>نام پلی‌لیست</InputLabel>
          <OutlinedInput
            id={"playlist-name"}
            value={name}
            onChange={onChangeName}
            required
            placeholder={"مثلاً بهترین‌های راک ۲۰۲۲"}
          />
          <FormControlLabel
            checked={isPublic}
            onChange={onChangeIsPublic}
            control={<Checkbox />}
            label="عمومی؟"
            labelPlacement="start"
            sx={{ mt: 2 }}
          />
        </Stack>
        <Stack direction={"row"} mx={1} mb={-1}>
          <Button
            onClick={onClose}
            variant={"contained"}
            color={"secondary"}
            sx={{ flex: 1, mr: 1 }}
          >
            {"انصراف"}
          </Button>
          <Button
            type={"submit"}
            variant={"contained"}
            sx={{ flex: 3 }}
            disabled={!user || name.length === 0 || isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : "ثبت تغییرات"}
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
};
